import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Gift } from 'lucide-react';
import { GrassDivider, LeafPattern } from './SectionDivider';
export function CTASection() {
  return <section className="py-24 bg-brand-gold text-black relative overflow-hidden" data-id="element-22">
      <GrassDivider fill="#0A0A0A" position="top" data-id="element-23" />

      {/* Background pattern */}
      <LeafPattern className="text-black opacity-5" data-id="element-24" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center mt-8" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-26">
          <div className="inline-flex items-center justify-center p-4 bg-black/10 rounded-full mb-8 backdrop-blur-sm" data-id="element-27">
            <Gift size={40} className="text-black" data-id="element-28" />
          </div>

          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-serif" data-id="element-29">
            Your Free Estimate Is Waiting
          </h2>

          <p className="text-xl md:text-2xl text-black/80 mb-12 font-light max-w-2xl mx-auto" data-id="element-30">
            No commitment. No pressure. Just a friendly conversation about how
            we can make your property look its absolute best.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-31">
            <a href="tel:4233203426" className="group flex items-center justify-center gap-3 bg-brand-black text-brand-gold px-10 py-5 rounded-full text-xl font-bold hover:bg-brand-dark transition-all duration-300 transform hover:scale-105 shadow-xl w-full sm:w-auto" data-id="element-32">
              <Phone size={24} className="group-hover:animate-bounce" data-id="element-33" />
              Call or Text Now
            </a>
            <div className="text-2xl font-bold tracking-wider text-black/80" data-id="element-34">
              423-320-3426
            </div>
          </div>

          <a href="mailto:eithanslandscapingjunkremoval@gmail.com" className="inline-flex items-center gap-2 mt-6 text-black/70 hover:text-black transition-colors font-medium" data-id="element-35">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-36">
              <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-37" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-38" />
            </svg>
            eithanslandscapingjunkremoval@gmail.com
          </a>
        </motion.div>
      </div>
    </section>;
}